
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 150.25 150.25"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"75.12","cy":"75.12","r":"75.12","fill":"#3b7cf7"}}),_c('polyline',{attrs:{"points":"55.13 83.64 96.23 83.64 96.23 120.7 55.13 120.7 55.13 93.2","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_c('path',{attrs:{"d":"M97.56,27.76H55.13c-2.2,0-4,1.41-4.19,3.23L43.28,61.34l-1.09,5.2-1,4.9a1.57,1.57,0,0,0,.47,1.41,2.37,2.37,0,0,0,1.61.62h66.21a2.37,2.37,0,0,0,1.61-.62,1.54,1.54,0,0,0,.47-1.41l-1-4.9-1.09-5.2L102.9,35.56","transform":"translate(-.67 -.67)","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_c('rect',{attrs:{"x":"66.66","y":"72.8","width":"18.05","height":"6.24","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_c('rect',{attrs:{"x":"65.27","y":"79.08","width":"20.83","height":"4.19","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}})])
          )
        }
      }
    